import CheckIcon from '@mui/icons-material/Check';
import { MenuItem } from '@mui/material';
import classNames from 'classnames';
import Header from 'components/Header/Header';
import HeaderIconLogo from 'components/Header/header-items/HeaderIconLogo';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import BlockTitle from '../../../../components/layout/BlockTitle/BlockTitle';
import Loader from '../../../../components/Loader/Loader';
import config, { Language } from '../../../../config';
import { useLanguage } from '../../../../hooks/useLanguage';
import useLoggedIn from '../../../../hooks/useLoggedIn';

const SelectLanguagePage = () => {
  const { t } = useTranslation();
  const router = useRouter();

  const { language: currentLanguage, availableLanguages, setLanguage, getLanguageWithTranslationLabel } = useLanguage();
  const isLoggedIn = useLoggedIn();

  const [isLoading, setLoading] = useState(false);

  const onSelect = async (language: Language) => {
    setLoading(true);

    await setLanguage({
      language,
      country: config.country,
      saveToDb: isLoggedIn,
    });

    setLoading(false);
    router.back();
  };

  return (
    <>
      <Header>
        <HeaderIconLogo icon="back" showLogo={false} />
      </Header>

      <div className="settings-detail-page settings-language-page mobile-full-width">
        <BlockTitle mt={0} className="settings-title">
          <img src="/icons/icn-earth.svg" className="settings-title-icon" alt="language" />
          {t('common.change-language')}
        </BlockTitle>

        <div className="language-select-container">
          {isLoading ? (
            <Loader className="mt-2" />
          ) : (
            availableLanguages.map((language) => (
              <MenuItem
                key={'language-selector-' + language} //
                className={classNames('language-dropdown-item', { checked: language === currentLanguage })}
                value={language}
                onClick={() => onSelect(language)}
              >
                {getLanguageWithTranslationLabel(language)}

                {language === currentLanguage && <CheckIcon className="check-icon" />}
              </MenuItem>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default SelectLanguagePage;
